import { vehicleManufacturersSlice } from "./vehicleManufacturersSlice";
import * as actions from "./vehicleManufacturersActions";
import * as selectors from "./vehicleManufacturersSelectors";

export { actions };
export { selectors };
export default vehicleManufacturersSlice.reducer;
